// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"26c7bde9","239":"6bb84735","455":"cc669dec"}[chunkId] + ".chunk.js";
};